<template>
	<div class="container-xl">
		<main class="py-4">
			<div class="row g-3 mb-4 align-items-center justify-content-between">
				<div class="col-auto">
					<h1 class="app-page-title mb-0">{{ __('questionnaires.listview-title') }}</h1>
				</div>
			</div>

			<div class="row">
				<div class="col-md-12">
					<div v-if="questionnaires.length > 0" class="app-card app-card-orders-table shadow-sm mb-5">
						<div class="app-card-body">
							<div class="table-responsive">
								<table class="table app-table-hover mb-0 text-left">
									<thead>
									<tr>
										<th class="cell">{{ __('questionnaires.name') }}</th>
										<th class="cell">{{ __('questionnaires.actions') }}</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="questionnaire in questionnaires">
										<td class="cell">{{ questionnaire.name }}</td>
										<td class="cell">
											<a class="btn btn-outline-success" :href="'questionnaires/' + questionnaire.id + '/fill '">{{ __('actions.fill') }}</a>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div v-else class="app-card alert alert-dismissible shadow-sm mb-5 border-left-decoration" role="alert">
						<div class="inner">
							<div class="app-card-body p-3 p-lg-4">
								<h3 class="mb-3">{{ __('questionnaires.no-questionnaires-title') }}</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
export default {
	props: {
		questionnairesProp: {
			type: Array,
			required: true,
		}
	},

	data() {
		return {
			questionnaires: this.questionnairesProp,
		}
	},

	methods: {
        getQuestionnaires: async function (){
            axios.get(`/get-questionnaires`)
                .then(response => {
                    this.questionnaires = response.data.questionnaires
                })
        }
	}
}
</script>
